import React, { useContext } from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import Home from "../Home/Home";
import Adventure from "../Adventure/Adventure";
import AdvDay from "../Adventure/AdvDay/AdvDay";
import Redirect from "../Redirect/Redirect";
import ProtectedRoute from "./ProtectedRoute";

import "../../styles/App.scss"; // don't remove this the whole page breaks
import Login from "../Account/Register/Login";
import { useAuth } from "../../context/AuthContext";
import ValidateAdventureRoute from "./ValidateAdventureRoute";
import Combat from "../Adventure/AdvDay/Combat/Combat";
import AdvDayDemo from "../Adventure/AdvDay/AdvDayDemo";
import Register from "../Account/Register/Register";
import ThankYou from "../Account/ThankYou/ThankYou";

const AppRouter = () => {
  const { isAuth } = useAuth();
  if (isAuth === null) {
    return <div>Loading...</div>; // Or any loading indicator
  }

  const router = createBrowserRouter([
    {
      path: "/",
      element: <Home />,
    },
    // {
    //   path: "/adventure/demo",
    //   element: <Adventure length={4} iteration={"demo"} />,
    // },
    {
      path: "/adventure/demo/:day",
      element: <AdvDayDemo />,
    },
    // Commenting out for now until the adventure is ready
    {
      path: "/account",
      element: <Login startPage="register" navTo="/adventure" />,
    },
    {
      path: "/account/thankyou",
      element: (
        <ProtectedRoute
          element={<ThankYou />}
          isAuthenticated={isAuth}
          path="/account"
        />
      ),
    },
    {
      path: "/adventure",
      element: (
        <ProtectedRoute
          element={<Adventure />}
          isAuthenticated={isAuth}
          path="/account"
        />
      ),
    },
    {
      path: "/adventure/:day",
      element: (
        <ProtectedRoute
          element={<AdvDay />}
          isAuthenticated={isAuth}
          path="/account"
        />
      ),
    },
    {
      path: "*",
      element: <Redirect to={"/"} />,
    },
  ]);

  return <RouterProvider router={router} />;
};

export default AppRouter;
